"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventValidationService = void 0;
var ajv_1 = __importDefault(require("ajv"));
var EventValidationService = /** @class */ (function () {
    function EventValidationService(timberService, commonSectionSchemas) {
        var _this = this;
        this.ajv = new ajv_1.default();
        this.timberService = timberService;
        commonSectionSchemas.forEach(function (commonSchema) { return _this.ajv.addSchema(commonSchema); });
    }
    EventValidationService.prototype.validateEventSchema = function (eventName, event, eventId, eventSchema) {
        var logParams = { module: 'validateEventSchema', extendedParameters: { eventName: eventName, event: event, eventId: eventId, sessionId: event.systemHeader.sessionId } };
        try {
            if (eventSchema) {
                var validate = this.ajv.compile(eventSchema);
                var valid = validate(event);
                if (valid) {
                    this.timberService.info("Event ".concat(eventName, " ").concat(eventId, " was validated successfully."), logParams);
                    return true;
                }
                this.timberService.error("Failed to validate eventSchema ".concat(JSON.stringify(validate.errors).replace("#", "")), logParams);
            }
            else {
                this.timberService.error("EventSchema parameter didn't initialized for ".concat(eventName, " ").concat(eventId), logParams);
            }
            return false;
        }
        catch (e) {
            this.timberService.error("Failed to validateEventSchema ".concat(JSON.stringify(e).replace("#", "")), logParams);
            return false;
        }
    };
    return EventValidationService;
}());
exports.EventValidationService = EventValidationService;
//# sourceMappingURL=eventValidation.service.js.map